export function loadingStart() {
  let loadingScreenContainer = document.getElementById("loading-screen");
  if (loadingScreenContainer) {
    return;
  }

  document.body.classList.add("page-loading");
}

export function loadingEnd(callback) {
  let loadingScreenContainer = document.getElementById("loading-screen");
  let time = 0;
  if (loadingScreenContainer) {
    time = 500;
  }

  setTimeout(() => {
    document.body.classList.add("page-loading--hide");
    document.body.classList.remove("page-loading");
    callback ? callback() : null;
  }, 100);

  setTimeout(() => {
    document.body.classList.remove("page-loading--hide");

    if (loadingScreenContainer) loadingScreenContainer.remove();
    $.post("/preloading", { preloading: 1 });
  }, time + 100);
}
